import React from "react";
import { useState, useRef, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import InputField from "../../../Components/InputField";
import styled from "styled-components";
import LeftLayout from "../../../Components/LeftLayout";
import LanguageComponent from "../../../Components/LangTranslation/LanguageComponent";
import { authRequest } from "../../../authentications/auth";
import { useLanguage } from "../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../authentications/SessionContext";
import emailicon from "../../../Images/email.svg";
import passwardicon from "../../../Images/lock.svg";
import { Formik } from "formik";
import SignInSchema from "../../../utilities/Validation Schema/SignInSchema";
import { getToken } from "../../../authentications/getCSRFToken";
import { webLoginApi } from "../../../authentications/webLogin";
import LoaderWrapper from "../../../Components/Loader/LoaderWrapper";
import Modal from "../../../Components/Kanban/Modal/Modal";
import { checkApi } from "../../../DataApi/onboarding/checkApi";
import { enqueueSnackbar } from "notistack";
import { destroySession } from "../../../authentications/destroySession";

import {
  backgroundColor,
  borderColor,
  prmiaryColor,
  textColor,
} from "../../../utilities/colors";
import { sessionAuth } from "../../../authentications/sessionAuth";
import VerifyEmail from "../VerifyEmail/VerifyEmail";

// Main container for the form
const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  width: 50%;
  padding: 33px;

  @media only screen and (max-width: 768px) {
    padding: 18px;
    width: 100%;
    .last_sec_signUp {
      font-size: 10px;
      font-weight: 500;
      text-align: center;
    }
  }
  .last_sec_signUp {
    margin-top: 20px;
    font-size: 16px;
    font-weight: 500;
  }
`;
const Title = styled.label`
  font-weight: 700;
  font-size: 32px;
  font-family: "Inter", sans-serif;

  @media only screen and (max-width: 1024px) {
    font-size: 26px;
  }
`;
const SigninSplit = styled.div`
  display: flex;
`;
const LoginText = styled.label`
  color: ${(props) => props.theme.textColor.primary};
  font-weight: 500;
  font-size: 17px;
  font-family: "Inter", sans-serif;
  margin: 20px 0 20px 0;

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;
const HorizontalLine = styled.div`
  text-align: center;
  font-size: 22px;
  color: ${(props) => props.theme.textColor.primary};
  margin: 22px 0px;
  margin-right: 140px;

  span {
    display: inline-block;
    position: relative;
  }

  span:before,
  span:after {
    content: "";
    position: absolute;
    top: 50%;
    width: 110px;
    height: 2px;
    background-color: ${(props) => props.theme.backgroundColor.primary};
  }
  span:before {
    right: 100%;
    margin-right: 10px;
  }
  span:after {
    left: 100%;
    margin-left: 10px;
  }
  @media only screen and (max-width: 1024px) {
    font-size: 17px;
    margin-right: 18px;
  }
  @media only screen and (max-width: 768px) {
    text-align: center;
    font-size: 16px;
    margin: 22px 0px;
    margin-right: 33px;
  }
`;
const Icon = styled.div`
  position: absolute;
  top: 36%;
  left: 10px; /* Adjust the left position as needed */
  transform: translateY(-50%);
  color: ${(props) => props.theme.borderColor.primary};
`;
const PasswordIcon = styled.div`
  position: absolute;
  top: 54%;
  left: 10px; /* Adjust the left position as needed */
  transform: translateY(-50%);
  color: ${(props) => props.theme.borderColor.primary};
`;
const SocialButtonsContainer = styled.div`
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    display: flex;
    gap: 15px;
    width: 100%;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    width: 100%;
    margin-top: 20px;
    gap: 10px;
  }
`;
// const SocialButton = styled.button`
//   width: 42%;
//   min-width: 42%;
//   border-radius: 14px;
//   border: none;
//   background-color: ${(props) => props.theme.backgroundColor.primary};
//   font-family: "Inter", sans-serif;
//   font-size: 18px;
//   font-weight: 500;
//   color: ${(props) => props.theme.textColor.primary};
//   line-height: 27px;
//   text-align: left;
//   display: flex;
//   align-items: center;
//   justify-content: space-evenly;
//   height: 58px;

//   @media only screen and (max-width: 768px) {
//     width: 65%;
//     border-radius: 12px;
//     border: none;
//     background-color: ${(props) => props.theme.backgroundColor.primary};
//     font-family: "Inter", sans-serif;
//     font-size: 10px;
//     font-weight: 500;
//     color: ${(props) => props.theme.textColor.primary};
//     display: flex;
//     justify-content: space-evenly;
//     height: 44px;
//   }
// `;
const LoginButton = styled.button`
  width: 65%;
  height: 60px;
  border-radius: 14px;
  font-family: "Comfortaa", sans-serif;
  background-color: ${(props) =>
    props["data-isvtex"] ? "#000000" : props.theme.primaryColor.primary};
  color: ${(props) =>
    props["data-isvtex"]
      ? props.theme.primaryColor.primary
      : props.theme.backgroundColor.secondary};
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  font-weight: 600;
  border-width: 0;
  margin-top: 65px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 768px) {
    width: 90%;
    font-size: 16px;
  }
`;
// const SocialButtonText = styled.span`
//   margin-left: 8px;
// `;
const ErrorDiv = styled.div`
  width: 65%;
  margin-top: 60px;
`;
const EmailInputDiv = styled.div`
  position: relative;
  .login_signup_inputs {
    width: 65%;
    height: 58px;
    padding-left: 40px;
    border-radius: 16px;
    box-shadow: 0 2px 4px 0 ${(props) => props.theme.borderColor.primary};
    background: ${(props) => props.theme.backgroundColor.primary};
    border-width: 0;
    /* position: relative; */
    margin-bottom: 20px;
    &:focus {
      border: 2px solid ${(props) => props.theme.primaryColor.primary};
      outline: none;
    }
  }

  .invalid-input {
    border-color: ${(props) => props.theme.primaryColor.error};
  }

  .error-message {
    color: ${(props) => props.theme.primaryColor.error};
  }

  @media only screen and (max-width: 768px) {
    .login_signup_inputs {
      width: 90%;
      height: 46px;
      padding-left: 40px;
      border-radius: 16px;
      box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%);
      background: ${(props) => props.theme.backgroundColor.primary} !important;
      border-width: 0;
      /* position: relative; */
      margin-bottom: 27px;
      color: ${(props) => props.theme.textColor.primary} !important;
    }
    .emailicon {
      position: absolute;
      top: 34%;
      padding: 5px;
      left: 4px;
      transform: translateY(-50%);
      color: ${(props) => props.theme.textColor.primary};
    }
  }
`;
const Inputs = styled.div`
  .forget_password {
    height: 20px;
    color: ${(props) => props.theme.textColor.primary};
    margin-top: 10px;
    font-size: 14px;
    font-family: "Montserrat";
    font-weight: 600;
    display: flex;
    justify-content: end;
    align-items: center;
    cursor: pointer;
  }
  .forget_password:hover {
    color: ${(props) => props.theme.primaryColor.primary};
  }
  .password-input {
    position: relative;
    width: 65%;
    height: 58px;
  }

  .passInput {
    width: 100%;
    height: inherit;
    border-radius: 14px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%);
    background: ${(props) => props.theme.backgroundColor.primary};
    border-width: 0;
    padding-left: 40px;
    margin-bottom: 10px;
    &:focus {
      border: 2px solid ${(props) => props.theme.primaryColor.primary};
      outline: none;
    }
  }
  .password-toggle {
    position: absolute !important;
    top: 32% !important;
    right: 10px !important;
    align-items: center !important;
    cursor: pointer !important;
    color: ${(props) => props.theme.borderColor.primary} !important;
    height: 15px !important;
    width: 22px !important;
  }
  @media only screen and (max-width: 768px) {
    .password-input {
      position: relative;
      align-items: center;
      width: 90%;
    }
    .passInput {
      width: 100%;
      height: 48px;
      border-radius: 14px;
      box-shadow: 0 2px 4px 0 ${(props) => props.theme.borderColor.primary};
      background: ${(props) => props.theme.backgroundColor.primary};
      border-width: 0;
      padding-left: 40px;
      margin-bottom: 10px;
    }
    .password-toggle {
      position: absolute;
      top: 27%;
      right: 10px;
      align-items: center;
      cursor: pointer;
      height: 15px;
      width: 22px;
    }
    .passicon {
      position: absolute;
      top: 46%;
      left: 10px;
    }
  }
`;
const SignUpText = styled.span`
  color: ${(props) => props.theme.primaryColor.primary};
  font-weight: 500;
  cursor: pointer;
`;

const SignIn = () => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const loginErrorRef = useRef(null);
  const loginRef = useRef(null);
  const [open2FAuthenticationModal, setopen2FAuthenticationModal] =
    useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpId, setOtpId] = useState(null);
  const [isOtpVerified, setIsOtpVerified] = useState(false);

  const [csrfToken, setCsrfToken] = useState(null);
  const {
    handleAuthentication,
    setSessInfo,
    sessionInfo,
    handleCheckSessions,
  } = useSession();
  const { isVTEX, VtexAdmin, ionAdmin } = sessionInfo;

  const togglePasswordVisibility = () => {
    setFormData({ ...formData, showPassword: !formData.showPassword });
  };
  const handleForgotPasswordClick = () => {
    navigate("/resetPassword");
  };
  const handleSignUpClick = () => {
    if (isVTEX) {
      navigate("/signup-info");
    } else {
      navigate("/signup");
    }
  };

  //send otp for 2 factor authetiction
  const handleSendOtp = async () => {
    console.log("otp send");
    if (!formData.email) {
      return;
    }

    setIsLoading(true);
    try {
      const response = await checkApi({
        params: { email: formData.email },
        endpoint: "/otp/send_email_otp",
      });
      console.log(response);

      if (response?.result?.code === 200) {
        setOtpId(response.result.vals);
        setIsOtpSent(true);
      } else {
        alert("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
    setIsLoading(false);
  };

  const handleVerifyOtp = async (otpCode) => {
    const params = { lead_id: otpId, otp: otpCode };
    const { email, password } = formData;

    try {
      const response = await checkApi({
        params,
        endpoint: "/otp/verify_email_otp",
      });

      if (response?.result?.success) {
        enqueueSnackbar("Authentication is done.", { variant: "success" });
        setIsOtpVerified(true);
        setopen2FAuthenticationModal(false);

        // Generate a new token after OTP verification
        const tokenResult = await getToken();
        if (tokenResult.success) {
          setCsrfToken(tokenResult.token);
        } else {
          
        }

        await webLoginApi(email, password, tokenResult.token);
        const result = await authRequest();

        if (result.success) {
          if (
            !window?.location?.port &&
            result?.merchant_domain &&
            window?.location?.origin !== result?.merchant_domain
          ) {
            const signinPath = result?.merchant_domain.includes("/merchant")
              ? `${result?.merchant_domain}/signin`
              : `${result?.merchant_domain}/merchant/signin`;

            window.location.href = signinPath;
            return;
          }
          setSessInfo(
            result.company_id,
            result.user_id,
            result.context,
            result.username,
            result.user_companies,
            result.suspended_merchant || false,
            result.company_partner_id,
            result.is_admin,
            result.is_vtex_admin,
            result.is_vtex_omantal,
            sessionInfo.isVTEX
          );
          handleAuthentication(true);
          localStorage.setItem("authenticated", JSON.stringify(true));
          if (loginErrorRef.current) {
            loginErrorRef.current.classList.add("d-none");
          }
        } else {
          localStorage.setItem("authenticated", JSON.stringify(false));
          if (loginErrorRef.current) {
            loginErrorRef.current.classList.remove("d-none");
            loginErrorRef.current.textContent = "Wrong login/password";
          }
        }
      } else {
        enqueueSnackbar("Invalid OTP! Please try again.", { variant: "error" });
      }
    } catch (error) {
      console.error("OTP verification failed:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "password" && loginErrorRef.current) {
      loginErrorRef.current.textContent = "";
      loginErrorRef.current.classList.add("d-none");
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    loginRef.current.disabled = true;
    setIsLoading(true);
    const { email, password } = formData;

    try {
      const loginResponse = await webLoginApi(email, password, csrfToken);
      console.log(loginResponse, "loginResponse");

      if (loginResponse === undefined) {
        if (loginErrorRef.current) {
          loginErrorRef.current.textContent = "";
          loginErrorRef.current.classList.add("d-none");
        }
      } else {
        if (loginErrorRef.current) {
          loginErrorRef.current.textContent = "Wrong login/password";
          loginErrorRef.current.classList.remove("d-none");
        }
        return;
      }
    } catch (error) {
      console.error("An error occurred:", error);
      if (loginErrorRef.current) {
        loginErrorRef.current.classList.remove("d-none");
        loginErrorRef.current.textContent =
          "An error occurred while authenticating";
      }
    } finally {
      if (loginRef.current) loginRef.current.disabled = false;
      setIsLoading(false);
    }

    await destroySession();

    setopen2FAuthenticationModal(true);

    if (!isOtpSent) {
      await handleSendOtp();
      enqueueSnackbar("OTP sent! Please verify before signing in.", {
        variant: "info",
      });
      return;
    }
  };

  const callCSRFApi = async () => {
    try {
      const result = await getToken();
      if (result.success) {
        setCsrfToken(result.token);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };
  useEffect(() => {
    callCSRFApi();
  }, []);

  return (
    <LoaderWrapper isLoading={!csrfToken} height="100vh" width="100vw">
      <Modal
        isOpen={open2FAuthenticationModal}
        onClose={() => setopen2FAuthenticationModal(false)}
      >
        <VerifyEmail
          mode="2fa"
          handleVerifyOtp={handleVerifyOtp}
          handleSendOtp={handleSendOtp}
        />
      </Modal>
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={SignInSchema}
        onSubmit={handleSubmit}
      >
        <SigninSplit>
          <LeftLayout />
          <div style={{ position: "absolute", top: 10, right: 10 }}>
            <LanguageComponent />
          </div>

          <FormContainer onSubmit={handleSubmit}>
            <Title>{t["Sign In"]}</Title>
            <LoginText>{t["Welcome Back You have been missed!"]}</LoginText>
            {/* <SocialButtonsContainer>
              <SocialButton>
                <img src={googleicon} alt="Google" />
                <SocialButtonText className="social_span">
                  {t["Sign In with Google"]}
                </SocialButtonText>
              </SocialButton>
              <SocialButton>
                <img src={appleicon} alt="Apple" />
                <SocialButtonText className="social_span">
                  {t["Sign In with Apple ID"]}
                </SocialButtonText>
              </SocialButton>
            </SocialButtonsContainer> */}
            {/* <HorizontalLine>
              <span>{t["OR"]} </span>
            </HorizontalLine> */}
            <EmailInputDiv>
              <Icon className="emailicon">
                <img src={emailicon} alt="emailIcon" />
              </Icon>
              <InputField
                type="text"
                name="email"
                value={formData.email}
                placeholder={t["Your Email"]}
                onChange={handleInputChange}
                onBlur={handleInputChange}
                className="login_signup_inputs"
              />
            </EmailInputDiv>
            <Inputs>
              <div className="password-input">
                <PasswordIcon className="passicon">
                  <img src={passwardicon} alt="emailIcon" />
                </PasswordIcon>
                <InputField
                  type={formData.showPassword ? "text" : "password"}
                  name="password"
                  value={formData.password}
                  placeholder={t["Create Password"]}
                  onChange={handleInputChange}
                  className="passInput"
                />
                <span
                  className="password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {formData.showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
                <div
                  className="forget_password"
                  onClick={handleForgotPasswordClick}
                >
                  <span>{t["Forget Password"]}</span>
                </div>
              </div>
            </Inputs>
            <ErrorDiv
              ref={loginErrorRef}
              className="loginError  d-none col-12 alert alert-danger"
              role="alert"
            ></ErrorDiv>
            <LoginButton
              ref={loginRef}
              disabled={isLoading || !csrfToken}
              type="submit"
              onClick={handleSubmit}
              data-isvtex={isVTEX}
              className="d-flex align-items-center justify-content-center"
            >
              {isLoading ? (
                <div className="spinner-border mx-2" role="status"></div>
              ) : (
                ""
              )}
              {!csrfToken ? (
                <span>{t["Please Wait"]}</span>
              ) : (
                <span>{`${t["Sign In"]}`}</span>
              )}
            </LoginButton>

            {(VtexAdmin || ionAdmin) && (
              <div className="last_sec_signUp">
                {t["Don't have an account yet?"]}{" "}
                <SignUpText onClick={handleSignUpClick}>
                  {t["Sign Up"]}
                </SignUpText>
              </div>
            )}
          </FormContainer>
        </SigninSplit>
      </Formik>
    </LoaderWrapper>
  );
};

export default SignIn;
